import React from 'react'
import "./How_It_works_card.css"

function How_It_works_card({number,heading,text}) {
    return (
        <>
            <section className='How_It_works_card'>
                <div className='number_holder'>
                    <h4>{number}.</h4>
                </div>

                <div className='text_holder'>
                    <h4>{heading}</h4>
                    <p>{text}</p>
                </div>
            </section>
        </>
    )
}

export default How_It_works_card